module.exports = __webpack_public_path__ + "static/media/DnDBg.eb0268af.svg";